import { put } from 'redux-saga/effects';

import { analyticsEventAction } from '@pressreader/analytics-core';
import { takeEvery } from '@pressreader/appstore';

import { openArticleShareMenuAction, openTranslationMenuAction, saveToCollectionRequestAction } from '../actions';

function* onOpenTranslationMenu() {
    yield put(analyticsEventAction({ category: 'Menus', action: 'IssueContextMenu', label: 'translate' }));
}

function* onOpenArticleShareMenu() {
    yield put(analyticsEventAction({ category: 'Menus', action: 'IssueContextMenu', label: 'share' }));
}

function* onSaveToCollectionRequest() {
    yield put(analyticsEventAction({ category: 'Menus', action: 'IssueContextMenu', label: 'bookmark' }));
}

export function* saga() {
    yield takeEvery(openTranslationMenuAction, onOpenTranslationMenu);
    yield takeEvery(openArticleShareMenuAction, onOpenArticleShareMenu);
    yield takeEvery(saveToCollectionRequestAction, onSaveToCollectionRequest);
}
